


const menuLinksSelectors = ["#mobile-vertical-header a"].join(',');


const onClick = e => {
  const closer = document.querySelector('.suki-popup-close');
  closer && closer.click();
  
 
};

export const cleanMobile = () => {
  const openers = document.querySelectorAll(menuLinksSelectors);
  openers.forEach(o => {
    o.removeEventListener("click", onClick);
  });
};

export const initMobile = () => {
  const openers = document.querySelectorAll(menuLinksSelectors);
 
  openers.forEach(o => {
    o.addEventListener("click", onClick);
  });
};






